// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3aqHQ","right":"styles_right__2QKNs"};